import RedirectLinkComponent from "../Elements/RedirectLinkComponent";
import dateTimeHelper from "../Helpers/datetimeHelper";
import AssignmentService from "../Services/AssignmentService";
import React from "react";

export default class LocationAssignmentItem {
  constructor(item) {
    if (item === undefined) {
      this.AsId = '';
      this.AsCuid = '';
      this.AsSassieReferenceNumber = '';
      this.AsLgsid = '';
      this.AsLdvid = '';
      this.AsLdvname = '';
      this.AsSassieShopComments = '';
      this.AsCfid = '';
      this.AsGroup = '';
      this.AsEvalFee = '';
      this.AsVat = '';
      this.AsBillToUnit = '';
      this.AsEvid = '';
      this.AsExclude = '';
      this.AsInid = '';
      this.AsUsid = '';
      this.AsUsname = '';
      this.AsMod = '';
      this.AsCreateId = '';
      this.AsCreateDt = '';
      this.AsSassieUnitId = '';
      this.AsSassieEvalId = '';
      this.AsSassieAsgnId = '';
      this.AsSassieSurveyId = '';
      this.AsEvaluatorCompletedDate = '';
      this.AsIob = '';
      this.AsUninvoiceable = '';
      this.AsPayEvaluator = '';
      this.AsBillClient = '';
      this.AsAdHocGroup = '';
      this.AsDeletedInApollo = '';
      this.IsApproved = '';
      this.AsFieldworkFee = '';
      this.AsIeFee = '';
      this.AsIeFeeAdjustment = '';
      this.AsIeReimbursement = '';
      this.AsIeTravel = '';
      this.AsIeGaming = '';
      this.AsIeMisc = '';
      this.AsIeFeeAdjustmentReason = '';
      this.AsIeReimbursementAdjustmentReason = '';
      this.AsIeEvaluatorCompletedDate = '';
      this.AsIeReceivedDate = '';
      this.AsIePaymentDate = '';
      this.LgsDesc = '';
      this.LgsComplete = '';
      this.CuId = '';
      this.CuName = '';
      this.CuCity = '';
      this.CuState = '';
      this.CuCountry = '';
      this.CuUserLocId = '';
      this.CcId = '';
      this.CcCompanyName = '';
      this.AsEvname = '';
      this.InId = '';
      this.InCiid = '';
      this.CiStatusCode = '';
      this.CiYrmo = '';
      this.InRcyid = '';
      this.InRcysymbol = '';
      this.InRcycode = '';
      this.InFee = '';
      this.InFieldworkFee = '';
      this.InFeeAddit = '';
      this.InReimbursement = '';
      this.InMisc = '';
      this.InTravel = '';
      this.InGaming = '';
      this.InCreditAmount = '';
      this.InLateFee = '';
      this.InInitialTotalDue = '';
      this.InVat = '';
      this.InCurrentTotalDue = '';
      this.AsCfname = '';
      this.AsCfDisplayName = '';
      this.AsPricingId = '';
      this.AsPricingName = '';
      this.IeId = '';
      this.IeFee = '';
      this.IeFeeAdjustment = '';
      this.IeReimbursement = '';
      this.IeMisc = '';
      this.IeTravel = '';
      this.IeGaming = '';
      this.IeVat = '';
      this.IeVatfee = '';
      this.IeVatreimb = '';
      this.IeDue = '';
      this.IeTotal = '';
      this.IeTotalFee = '';
      this.IeTotalReimb = '';
      this.IeStatusCode = '';
      this.IePaymentDate = '';
      this.IeRcyid = '';
      this.IeRcyname = '';
      this.IeRcysymbol = '';
      this.AsRcyid = '';
      this.AsRcycode = '';
      this.AsRcysymbol = '';
      this.AsRcyidOwningOffice = '';
      this.AsRcycodeOwningOffice = '';
      this.AsRcysymbolOwningOffice = '';
      this.AsPricingRoundFee = '';
      this.AsFee = '';
      this.AsFeeOwningOffice = '';
      this.AsFeeAddit = '';
      this.AsFeeReason = '';
      this.AsReimbursement = '';
      this.AsMisc = '';
      this.AsTravel = '';
      this.AsGaming = '';
      this.CountryId = '';
      this.CountryName = '';
      this.EvaluatorOfficeId = '';
      this.EvaluatorOfficeName = '';
      this.EvaluatorCurrencyId = '';
      this.EvaluatorCurrencyName = '';
      this.ReimbursementCurrencyId = '';
      this.ReimbursementCurrencyName = '';
      this.ClientReimbursementCurrencyId = '';
      this.ClientReimbursementCurrencyName = '';
      this.ClientBillingCurrencyName = '';
      this.ClientBillingCurrencyId = '';
      this.AsWaveId = '';
      this.AsWaveName = '';
      this.CuLevel1Name = '';
      this.CuLevel2Name = '';
      this.CuLevel3Name = '';
      this.CuLevel4Name = '';
      this.CuLevel5Name = '';
      this.AsSelf = '';
      this.InFeeWithSymbol = '';
      this.InFeeAdditWithSymbol = '';
      this.IeReimbursementWithSymbol = '';
      this.InTravelWithSymbol = '';
      this.InGamingWithSymbol = '';
      this.InMiscWithSymbol = '';
      this.InFieldworkFeeWithSymbol = '';
      this.AsEvaluatorCompletedDateFormatted = '';
      return;
    }
    this.AsId = item.asId;
    this.AsCuid = item.asCuid;
    this.AsSassieReferenceNumber = item.asSassieReferenceNumber;
    this.AsLgsid = item.asLgsid;
    this.AsLdvid = item.asLdvid;
    this.AsLdvname = item.asLdvname;
    this.AsSassieShopComments = item.asSassieShopComments;
    this.AsCfid = item.asCfid;
    this.AsGroup = item.asGroup;
    this.AsEvalFee = item.asEvalFee;
    this.AsVat = item.asVat;
    this.AsBillToUnit = item.asBillToUnit;
    this.AsEvid = item.asEvid;
    this.AsExclude = item.asExclude;
    this.AsInid = item.asInid;
    this.AsUsid = item.asUsid;
    this.AsUsname = item.asUsname;
    this.AsMod = item.asMod;
    this.AsCreateId = item.asCreateId;
    this.AsCreateDt = item.asCreateDt;
    this.AsSassieUnitId = item.asSassieUnitId;
    this.AsSassieEvalId = item.asSassieEvalId;
    this.AsSassieAsgnId = item.asSassieAsgnId;
    this.AsSassieSurveyId = item.asSassieSurveyId;
    this.AsEvaluatorCompletedDate = item.asEvaluatorCompletedDate;
    this.AsIob = item.asIob;
    this.AsUninvoiceable = item.asUninvoiceable;
    this.AsPayEvaluator = item.asPayEvaluator;
    this.AsBillClient = item.asBillClient;
    this.AsAdHocGroup = item.asAdHocGroup;
    this.AsDeletedInApollo = item.asDeletedInApollo;
    this.IsApproved = item.isApproved;
    this.AsFieldworkFee = item.asFieldworkFee;
    this.AsIeFee = item.asIeFee;
    this.AsIeFeeAdjustment = item.asIeFeeAdjustment;
    this.AsIeReimbursement = item.asIeReimbursement;
    this.AsIeTravel = item.asIeTravel;
    this.AsIeGaming = item.asIeGaming;
    this.AsIeMisc = item.asIeMisc;
    this.AsIeFeeAdjustmentReason = item.asIeFeeAdjustmentReason;
    this.AsIeReimbursementAdjustmentReason = item.asIeReimbursementAdjustmentReason;
    this.AsIeEvaluatorCompletedDate = item.asIeEvaluatorCompletedDate;
    this.AsIeReceivedDate = item.asIeReceivedDate;
    this.AsIePaymentDate = item.asIePaymentDate;
    this.LgsDesc = item.lgsDesc;
    this.LgsComplete = item.lgsComplete;
    this.CuId = item.cuId;
    this.CuName = item.cuName;
    this.CuCity = item.cuCity;
    this.CuState = item.cuState;
    this.CuCountry = item.cuCountry;
    this.CuUserLocId = item.cuUserLocId;
    this.CcId = item.ccId;
    this.CcCompanyName = item.ccCompanyName;
    this.AsEvname = item.asEvname;
    this.InId = item.inId;
    this.InCiid = item.inCiid;
    this.CiStatusCode = item.ciStatusCode;
    this.CiYrmo = item.CiYrmo;
    this.InRcyid = item.inRcyid;
    this.InRcysymbol = item.inRcysymbol;
    this.InRcycode = item.inRcycode;
    this.InFee = item.inFee;
    this.InFieldworkFee = item.inFieldworkFee;
    this.InFeeAddit = item.inFeeAddit;
    this.InReimbursement = item.inReimbursement;
    this.InMisc = item.inMisc;
    this.InTravel = item.inTravel;
    this.InGaming = item.inGaming;
    this.InCreditAmount = item.inCreditAmount;
    this.InLateFee = item.inLateFee;
    this.InInitialTotalDue = item.inInitialTotalDue;
    this.InVat = item.inVat;
    this.InCurrentTotalDue = item.inCurrentTotalDue;
    this.AsCfname = item.asCfname;
    this.AsCfDisplayName = item.asCfDisplayName;
    this.AsPricingId = item.asPricingId;
    this.AsPricingName = item.asPricingName;
    this.IeId = item.ieId;
    this.IeFee = item.ieFee;
    this.IeFeeAdjustment = item.ieFeeAdjustment;
    this.IeReimbursement = item.ieReimbursement;
    this.IeMisc = item.ieMisc;
    this.IeTravel = item.ieTravel;
    this.IeGaming = item.ieGaming;
    this.Ievat = item.ievat;
    this.IeVatfee = item.ieVatfee;
    this.IeVatreimb = item.ieVatreimb;
    this.IeDue = item.ieDue;
    this.IeTotal = item.ieTotal;
    this.IeTotalFee = item.ieTotalFee;
    this.IeTotalReimb = item.ieTotalReimb;
    this.IeStatusCode = item.ieStatusCode;
    this.IePaymentDate = item.iePaymentDate;
    this.IeRcyid = item.ieRcyid;
    this.IeRcyname = item.ieRcyname;
    this.IeRcysymbol = item.ieRcysymbol;
    this.AsRcyid = item.asRcyid;
    this.AsRcycode = item.asRcycode;
    this.AsRcysymbol = item.asRcysymbol;
    this.AsRcyidOwningOffice = item.asRcyidOwningOffice;
    this.AsRcycodeOwningOffice = item.asRcycodeOwningOffice;
    this.AsRcysymbolOwningOffice = item.asRcysymbolOwningOffice;
    this.AsPricingRoundFee = item.asPricingRoundFee;
    this.AsFee = item.asFee;
    this.AsFeeOwningOffice = item.asFeeOwningOffice;
    this.AsFeeAddit = item.asFeeAddit;
    this.AsFeeReason = item.asFeeReason;
    this.AsReimbursement = item.asReimbursement;
    this.AsMisc = item.asMisc;
    this.AsTravel = item.asTravel;
    this.AsGaming = item.asGaming;
    this.CountryId = item.countryId;
    this.CountryName = item.countryName;
    this.EvaluatorOfficeId = item.evaluatorOfficeId;
    this.EvaluatorOfficeName = item.evaluatorOfficeName;
    this.EvaluatorCurrencyId = item.evaluatorCurrencyId;
    this.EvaluatorCurrencyName = item.evaluatorCurrencyName;
    this.ReimbursementCurrencyId = item.reimbursementCurrencyId;
    this.ReimbursementCurrencyName = item.reimbursementCurrencyName;
    this.ClientReimbursementCurrencyId = item.clientReimbursementCurrencyId;
    this.ClientReimbursementCurrencyName = item.clientReimbursementCurrencyName;
    this.ClientBillingCurrencyName = item.inRcycode;
    this.ClientBillingCurrencyId = item.inRcyid;
    this.AsWaveId = item.asWaveId;
    this.AsWaveName = item.asWaveName;
    this.CuLevel1Name = item.cuLevel1Name;
    this.CuLevel2Name = item.cuLevel2Name;
    this.CuLevel3Name = item.cuLevel3Name;
    this.CuLevel4Name = item.cuLevel4Name;
    this.CuLevel5Name = item.cuLevel5Name;
    this.AsSelf = item.asSelf;
    this.InFeeWithSymbol = LocationAssignmentItem.getValueWithSymbol(
      item.lgsDesc,
      item.asBillClient,
      item.inRcysymbol,
      item.inFee
    );
    this.InFeeAdditWithSymbol = LocationAssignmentItem.getValueWithSymbol(
      item.lgsDesc,
      item.asBillClient,
      item.inRcysymbol,
      item.inFeeAddit
    );
    this.IeReimbursementWithSymbol = LocationAssignmentItem.getValueWithSymbol(
      item.lgsDesc,
      item.asBillClient,
      item.inRcysymbol,
      item.inReimbursement
    );
    this.InTravelWithSymbol = LocationAssignmentItem.getValueWithSymbol(
      item.lgsDesc,
      item.asBillClient,
      item.inRcysymbol,
      item.inTravel
    );
    this.InGamingWithSymbol = LocationAssignmentItem.getValueWithSymbol(
      item.lgsDesc,
      item.asBillClient,
      item.inRcysymbol,
      item.inGaming
    );
    this.InMiscWithSymbol = LocationAssignmentItem.getValueWithSymbol(
      item.lgsDesc,
      item.asBillClient,
      item.inRcysymbol,
      item.inMisc
    );
    this.InFieldworkFeeWithSymbol = LocationAssignmentItem.getValueWithSymbol(
      item.lgsDesc,
      item.asBillClient,
      item.inRcysymbol,
      item.inFieldworkFee
    );
    this.AsEvaluatorCompletedDateFormatted = dateTimeHelper.toYYYYsMMsDD(item.asEvaluatorCompletedDate, '-');
  }

  static getValueWithSymbol(desc, billClient, symbol, value) {
    if (desc !== null && desc === 'Excluded' && billClient !== true) {
      return '';
    }
    if (symbol === null) {
      if (value === null) {
        return "0.00";
      }
      return parseFloat(value).toFixed(2);
    } else {
      if (value === null) {
        return `${symbol} 0.00`;
      }
      return `${symbol} ${parseFloat(value).toFixed(2)}`;
    }
  }

  static NameOfTheIdField() {
    return "AsId";
  }
  static nameOfTheItemDetailList() {
    return "Assignment";
  }

  static MoneyFields = [
    // "AsFee"	,
    // "AsFieldworkFee",
    // "InFieldworkFee",
    // "AsPricingRoundFee",
    // "AsFeeAddit",
    // "AsFeeOwningOffice",
    // "AsReimbursement",
    // "IeDue",
    // "InFee",
    // "InFeeAddit",
    // "AsIeReimbursement",
    // "IeTotal",
    // "IeMisc",
    // "IeMisc",
    // "IeTravel",
    // "IeGaming",
    // "IeTotal",
    // "Ievat",
  ];

  static numberWithTwoDecimalPlaces = [
    "IeFee",
    "IeFeeAdjustment",
    "IeReimbursement",
    "IeMisc",
    "IeTravel",
    "IeGaming",
    "Ievat",
    "IeTotal",
    "IeDue",
    "InFee",
    "InFeeAddit",
    "InReimbursement",
    "InInitialTotalDue",
    "InMisc",
    "InVat",
    "InTravel",
    "InCreditAmount",
    "InGaming",
    "AsFeeOwningOffice",
    "AsFee",
    "AsFieldworkFee",
    "InFieldworkFee",
    "AsFeeAddit",
    "AsReimbursement",
    "AsMisc",
    "AsTravel",
    "AsGaming",
    "AsIeFee",
    "AsIeFeeAdjustment",
    "AsIeReimbursement",
    "AsIeMisc",
    "AsIeTravel",
    "AsIeGaming",
    "IeDue",
    "InCurrentTotalDue",
  ];

  static Currency() {
    return "";
  }

  static MoneyFieldsSecondary = [
    // "AsReimbursementv",
    // "AsMisc",
    // "AsTravel",
    // "AsGaming",
    // "AsIeFee",
    // "AsIeMisc",
    // "AsIeTravel",
    // "AsIeGaming",
    // "AsIeReimbursement",
  ];

  static CurrencySecondary() {
    return "";
  }

  static DateFields = [];

  static BoolFields = [];

  static idFunction(item) {
    return (
      <RedirectLinkComponent
        path="assignments"
        tooltipText={item.AsSassieAsgnId}
        text={item.AsSassieAsgnId}
        keyValuePairs={[
          { key: "AsBillClient", value: "" },
          { key: "AsPayEvaluator", value: "" },
          { key: "AsSassieAsgnId", value: item.AsSassieAsgnId },
        ]}
      />
    );
  }

  static FieldsToShowInDataTable() {
    return [
      { label: "Apollo ID", orderById: "AsSassieAsgnId", data: LocationAssignmentItem.idFunction, className: "text-center", minWidth: 50 },
      { label: "Invoice", orderById: "InCiid", data: "InCiid", className: "text-center", minWidth: 50 },
      { label: "Client Fee", orderById: "InFeeWithSymbol", data: "InFeeWithSymbol", className: "text-center", minWidth: 50 },
      { label: "Addit. Fee", orderById: "InFeeAdditWithSymbol", data: "InFeeAdditWithSymbol", className: "text-center", minWidth: 50 },
      { label: "Reimb.", orderById: "IeReimbursementWithSymbol", data: "IeReimbursementWithSymbol", className: "text-center", minWidth: 50 },
      { label: "Travel", orderById: "InTravelWithSymbol", data: "InTravelWithSymbol", className: "text-center", minWidth: 50 },
      { label: "Gaming", orderById: "InGamingWithSymbol", data: "InGamingWithSymbol", className: "text-center", minWidth: 50 },
      { label: "Misc", orderById: "InMiscWithSymbol", data: "InMiscWithSymbol", className: "text-center", minWidth: 50 },
      { label: "FW Office", orderById: "AsLdvname", data: "AsLdvname", className: "text-center", minWidth: 50 },
      { label: "FW Fee", orderById: "InFieldworkFeeWithSymbol", data: "InFieldworkFeeWithSymbol", className: "text-center", minWidth: 50 },
      { label: "Status", orderById: "LgsDesc", data: "LgsDesc", className: "text-center", minWidth: 50 },
      { label: "Completed Date", orderById: "AsEvaluatorCompletedDateFormatted", data: "AsEvaluatorCompletedDateFormatted", className: "text-center", minWidth: 50 },
    ];
  }

  static serviceFunctionForListTable = (item) => AssignmentService.GetAssignmentById(item.AsId);
  static FieldsToShowInListTable = [];
}
